export { AnimatedWritingDots } from './animated-writing-dots';
